import { ApiClient } from "@/services/ApiService";

export default {
  postLogin(credentials) {
    return ApiClient.post("auth/token", credentials);
  },
  refreshAuthToken(tokens) {
    return ApiClient.post("/auth/refreshtoken", tokens);
  }
};
